import TGASDK from './TGASDK'
import type { TGASDKContext } from './types'

class BaseModule {
  public static clazz = 'UNSET'

  public context: TGASDKContext
  public SDK: typeof TGASDK

  constructor(context: TGASDKContext) {
    this.context = context
    this.SDK = TGASDK
  }

  public run(): void {
    throw new Error(`you have to implement method of 'run'`)
  }
}

export default BaseModule
